import React from 'react';
import { FormattedMessage, injectIntl } from 'react-intl';
import useStyles from 'isomorphic-style-loader/useStyles';
import s from './HowItWorks.css';
import useScrollReveal from '../../hooks/useScrollReveal';
import messages from '../../../../locale/messages';

const steps = [
  {
    number: '01',
    icon: '🍽️',
    image: '/SiteImages/step1.webp',
    title: messages.homeStepOneTitle,
    desc: messages.homeStepOneDesc,
  },
  {
    number: '02',
    icon: '📋',
    image: '/SiteImages/step3.webp',
    title: messages.homeStepTwoTitle,
    desc: messages.homeStepTwoDesc,
  },
  {
    number: '03',
    icon: '📦',
    image: '/SiteImages/step2.webp',
    title: messages.homeStepThreeTitle,
    desc: messages.homeStepThreeDesc,
  },
];

function HowItWorks({ intl }) {
  useStyles(s);
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="how-it-works" className={s.section} ref={ref}>
      <div className={s.inner}>
        <p className={`${s.eyebrow} ${isVisible ? s.eyebrowVisible : ''}`}>
          <FormattedMessage {...messages.homeStepsEyebrow} />
        </p>
        <h2 className={`${s.title} ${isVisible ? s.titleVisible : ''}`}>
          <FormattedMessage {...messages.homeHowItWorksTitle} />
        </h2>

        <div className={s.timeline}>
          {steps.map((step, i) => (
            <div
              key={step.number}
              className={`${s.step} ${isVisible ? s.stepVisible : ''}`}
              style={{ transitionDelay: isVisible ? `${0.2 + i * 0.15}s` : '0s' }}
            >
              <div className={s.stepLeft}>
                <div className={s.numberBadge}>{step.number}</div>
                {i < steps.length - 1 && <div className={s.line} />}
              </div>

              <div className={s.stepRight}>
                <div className={s.imageWrap}>
                  <img
                    src={step.image}
                    alt={intl.formatMessage(step.title)}
                    className={s.image}
                    onError={(e) => {
                      e.currentTarget.style.display = 'none';
                      e.currentTarget.nextSibling.style.display = 'flex';
                    }}
                  />
                  <span className={s.fallbackIcon}>{step.icon}</span>
                </div>

                <div className={s.content}>
                  <h3 className={s.stepTitle}>
                    <FormattedMessage {...step.title} />
                  </h3>
                  <p className={s.stepDesc}>
                    <FormattedMessage {...step.desc} />
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export default injectIntl(HowItWorks);
